/**
 * Opens the document workbench dialog for an AI queue item.
 * Uses the Quasar Dialog plugin with the QueueWorkbenchDialog component.
 * @module useQueueDetailsDialog
 */
import { Dialog } from 'quasar'
import QueueWorkbenchDialog from '../components/QueueWorkbenchDialog.vue'
import type { AiQueueItem } from '../types'

/**
 * Opens the workbench for the given queue item.
 *
 * @param item - The item as known by the list; the dialog refetches it with stages
 * @param onMutated - Called after any successful action inside the dialog (retry,
 *                    cancel, delete, model confirmation) so the list can refresh
 */
export function openQueueWorkbenchDialog(item: AiQueueItem, onMutated?: () => void): void {
  Dialog.create({
    component: QueueWorkbenchDialog,
    componentProps: { initialItem: item, onMutated },
  })
}
